import { Box, IconButton, Typography } from '@mui/material';
import CaseBreadcrumbs from './components/CaseBreadcrumbs/CaseBreadcrumbs';
import WorkspaceInfo from './components/WorkspaceInfo/WorkspaceInfo';
import UserInfo from './components/UserInfo/UserInfo';
import { useContext, useEffect } from 'react';
import { IconArrowBack, IconSettings } from '../../../../common/images';
import { GlobalContext } from '../../../../common/contexts/globalContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { COLORS } from 'src/common/constants/constants';
import { i18n } from 'src/common/i18n/i18n';
import Notifications from './components/Notifications/Notifications';
import { AuthContext } from 'src/common/contexts/authContext';

const AppHeader = () => {
    const { user } = useContext(AuthContext);
    const { uiData, workspacesData, casesData } = useContext(GlobalContext);
    const navigate = useNavigate();
    const location = useLocation();

    const onNavigateBack = () =>
        navigate(`/collections?workspaceId=${workspacesData.activeWorkspace.id}&caseId=${casesData.activeCaseId}`);

    useEffect(() => {
        if (workspacesData?.workspaces?.length === 0 && user.role !== 'Regular') {
            navigate('/admin');
        }
    }, [workspacesData?.workspaces]);

    return (
        <Box
            sx={{
                ...(location.pathname.includes('/admin')
                    ? { width: '100%', borderBottom: `2px solid ${COLORS.MUTED_LIGHTEST}`, zIndex: 1299 }
                    : {
                          width: uiData.sidebarIsOpen ? 'calc(100% - 280px)' : 'calc(100% - 80px)',
                          left: uiData.sidebarIsOpen ? 280 : 80,
                          zIndex: 5,
                      }),
                height: '84px',
                display: 'flex',
                position: 'fixed',
                top: 0,
                backgroundColor: '#fff',
                alignItems: 'center',
                justifyContent: 'space-between',
            }}
        >
            {location.pathname.includes('/admin') ? (
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <IconButton
                        onClick={onNavigateBack}
                        sx={{
                            backgroundColor: `${COLORS.MUTED_SOFT} !important`,
                            width: '40px',
                            height: '40px',
                            ml: '40px',
                            mr: '28px',
                        }}
                        disabled={workspacesData.activeWorkspace === null}
                    >
                        <IconArrowBack />
                    </IconButton>

                    <Typography variant="s16w500">{i18n.translate('Admin Settings')}</Typography>
                </Box>
            ) : (
                <CaseBreadcrumbs />
            )}

            <Box sx={{ display: 'flex', my: '5px', mr: 5 }}>
                <Box
                    sx={{
                        display: 'inline-flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                    }}
                >
                    <WorkspaceInfo />
                    <Notifications />
                    <UserInfo />
                    {user.role === 'Administrator' && (
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <IconButton
                                disabled={!workspacesData.workspaces?.length}
                                className="color-mh"
                                sx={{ ml: 1.5, mr: 2, opacity: workspacesData.workspaces?.length ? 1 : 0.5 }}
                                onClick={() => {
                                    uiData.setSidebarIsOpen(true);

                                    if (location.pathname.includes('/admin')) {
                                        onNavigateBack();
                                    } else {
                                        navigate('/admin');
                                    }
                                }}
                            >
                                <Box
                                    className="background-color-mho"
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        p: 1,
                                        borderRadius: '61px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    <IconSettings fontSize="inherit" className="fill-md" />
                                </Box>
                            </IconButton>
                        </Box>
                    )}
                </Box>
            </Box>
        </Box>
    );
};

export default AppHeader;
